import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BackgroundImagesComponent } from '../background-images/background-images.component';
import { BigTitleComponent } from './big-title/big-title.component';
import { ContactBlockModule } from './contact-block/contact-block.module';
import { LogoComponent } from './logo/logo.component';
import { SpotlightSectionComponent } from './spotlight-section.component';
import { VerticalCopyrightComponent } from './vertical-copyright/vertical-copyright.component';

@NgModule({
  declarations: [
    SpotlightSectionComponent,
    LogoComponent,
    BigTitleComponent,
    BackgroundImagesComponent,
    VerticalCopyrightComponent
  ],
  imports: [CommonModule, ContactBlockModule],
  exports: [SpotlightSectionComponent]
})
export class SpotlightSectionModule {}
